// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-light text-muted py-4 mt-5">
      <div className="container">
        <div className="row">
          <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
            <p className="mb-0">
              Taxi-Local.uk © {new Date().getFullYear()}. All rights reserved.
            </p>
          </div>
          <div className="col-md-6 text-center text-md-end">
            <div className="mb-2">
              <Link to="/terms" className="text-decoration-none text-muted me-3">
                Terms & Conditions
              </Link>
              <Link to="/privacy-policy" className="text-decoration-none text-muted me-3">
                Privacy Policy
              </Link>
              <Link to="/cookies-policy" className="text-decoration-none text-muted">
                Cookie Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
